import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import React from "react";
import Header from "./components/Header";
import Home from "./components/Home";
import About_Education_Award from "./components/About_Education_Award";
import Company_About from "./components/Company_About";
import Our_Mission from "./components/Our_Mission";
import Our_Values from "./components/Our_Values";
import Other_Award from "./components/Other_Award";
import Guest_And_Speaker from "./components/Guest_And_Speaker";
import Photo from "./components/Photo";
import Video from "./components/Video";
import FAQ from "./components/FAQ";
import Nomination from "./components/Nomination";
import Contact_us from "./components/Contact_us";




import "./styles/App.scss";
import "./styles/Header.scss";
import "./styles/Home.scss";
import "./styles/Footer.scss";
import "./styles/Our_partner.scss";
import "./styles/Previous_partner.scss";
import "./styles/Our_Services.scss";
import "./styles/Questions.scss";
import "./styles/Company_About.scss";
import "./styles/Our_Mission.scss";
import "./styles/Our_Values.scss";
import "./styles/About_Education_Award.scss";
import "./styles/Guest_And_Speaker.scss";
import "./styles/Video.scss";
import "./styles/Nomination.scss";
import "./styles/Photo.scss";
import "./styles/Contact_us.scss";
import "./styles/Other_Award.scss";
import "./styles/IndiaBrandicon.scss";
import "./styles/LeadershipAwards.scss";
import "./styles/Indiaicon.scss";



const App = () =>
{
  return(
    <Router>
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/Company_About" element={
        <Company_About/>}
        />
        <Route path="/About_Education_Award" element={<About_Education_Award/>}/> 
        <Route path="/Our_Mission" element={<Our_Mission/>}/>
        <Route path="Our_Values" element={<Our_Values/>}/>
        <Route path="Other_Award" element={<Other_Award/>}/>
        <Route path="Guest_And_Speaker" element={<Guest_And_Speaker/>}/>
        <Route path="Photo" element={<Photo/>}/>
        <Route path="Video" element={<Video/>}/>
        <Route path="FAQ" element={<FAQ/>}/>
        <Route path="Nomination" element={<Nomination/>}/>
        <Route path="Contact_us" element={<Contact_us/>}/>
      </Routes>
    </Router>
  )
}

export default App;